import {Injectable, inject} from "@angular/core";
import {HttpService} from "../http/httpservice.service";
import {Employee} from "../../models/types/employee";
import {ApiResponse} from "../../models/types/api-response";
import {BranchAvailability} from "../../models/types/branch-availability";
import {Observable, catchError, debounceTime, map, of, switchMap, take, tap, throwError} from "rxjs";
import {ApiError} from "../../models/types/api-error";
import {GenericResult} from "../../models/types/generic-result";

@Injectable({
    providedIn: "root"
})
export class EmployeeService {
    private httpService: HttpService = inject(HttpService);
    constructor() {}

    public getBranchAvailabilities(
      branchId: number,
        date?: Date,
        debounce: number = 500
    ): Observable<GenericResult<BranchAvailability>>
    {

        return this.getBranchAvailabilitiesRequest(branchId, debounce, date).pipe(map(this.mapHandler));
    }

    public saveEmployee(employee: Employee): Observable<GenericResult<Employee>> {
        return this.saveEmployeeRequest(employee).pipe(map(this.mapHandler));
    }

    public updateEmployee(employee: Employee): Observable<GenericResult<Employee>> {
        return this.updateEmployeeRequest(employee).pipe(map(this.mapHandler));
    }

    private mapHandler<T>(response: ApiResponse<T>) {
        if (response.isFailure) {
            return <GenericResult<T>>{
                result: null,
                errors: response.errors
            };
        }

        if (response.isSuccess) {
            return <GenericResult<T>>{
                result: response.value,
                errors: null
            };
        }

        return <GenericResult<T>>{
            result: null,
            errors: "An error has occured"
        };
    }

    private saveEmployeeRequest(employeeModel: Employee) {
        return this.httpService.post<ApiResponse<Employee>>("/api/lead/employee", employeeModel);
    }

    private deleteEmployeeRequest(employeeId: number) {
        return this.httpService.delete<ApiResponse<Employee>>(`/api/lead/employee/${employeeId}`);
    }

    private updateEmployeeRequest(employeeModel: Employee) {
        return this.httpService.put<ApiResponse<Employee>>("/api/lead/employee", JSON.stringify(employeeModel));
    }

  private getBranchAvailabilitiesRequest(branchId: number, debounce: number, date?: Date) {
        return this.httpService
            .get<ApiResponse<BranchAvailability>>("/api/lead/availability/" + branchId + (date ? `/${date.toISOString()}` : ""))
            .pipe(debounceTime(debounce));
    }
}
